
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Hybrid Apps`}</h3>
    <p>{`Hybrid app support. We now support NativeScript for iOS and Android app development using Angular, TypeScript and JavaScript. NativeScript allows you to use your existing web development skills to build native apps for iOS and Android that share a single common codebase. You can read more in our guide.`}</p>
    <h3>{`Project Tool`}</h3>
    <p>{`The PX Blue 2.1 release also includes an early beta version of the PX Blue Project Tool. Designed to get developers started as quickly as possible with PX Blue, the PX Blue Project Tool provides a graphical or command line interface for creating and updating PX Blue projects without having to go through a bunch of manual configuration. You can read more in our Project Tool introduction.`}</p>
    <h3>{`Alignment with Marketing`}</h3>
    <p>{`PX Blue continues to improve its alignment with Corporate Branding and Marketing. Open Sans is now officially supported for application development.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;